export enum ContextEnum {
  UserPanel = 1,
  PayamakSefid = 2
}
